define('home/views/GenericCardCollectionView',[
    'underscore',
    'backbone',

    'home/views/common/FetchableCollectionView',
    'home/views/GenericCardCreateView',
    'home/views/GenericCardFavoriteView',
    'home/views/GenericCardTrendingView',
], function (
    _,
    Backbone,

    FetchableCollectionView,
    GenericCardCreateView,
    GenericCardFavoriteView,
    GenericCardTrendingView
) {
    'use strict';

    var GenericCardCollectionView = FetchableCollectionView.extend({
        itemView: function (options) {
            switch (options.model.get('verb')) {
            case 'favorite':
                return new GenericCardFavoriteView(options);
            case 'create':
                return new GenericCardCreateView(options);
            case 'trending':
                return new GenericCardTrendingView(options);
            case 'share':
                // Until we have a view that handles the share activity,
                // show a Create view for user-generated threads and a
                // Trending view otherwise.
                if (options.model.thread.author) {
                    if (!options.model.actors.length) {
                        // Since the share activity doesn't have actors and
                        // the Create view requires actors, set the actor to
                        // the thread author
                        options.model.actors = [options.model.thread.author];
                        options.model.set({ totalActors: 1 });
                    }

                    return new GenericCardCreateView(options);
                }

                return new GenericCardTrendingView(options);
            default:
                // So that an error isn't thrown by returning null when a view is
                // expected, for activity types not supported by generic feeds
                return new Backbone.View();
            }
        },

        itemViewOptions: function () {
            var existingOptions = FetchableCollectionView.prototype.itemViewOptions;
            if (_.isFunction(existingOptions))
                existingOptions = existingOptions.apply(this, arguments);

            var options = _.defaults({
                channel: this.channel,
                hideImage: this.hideImage,
            }, existingOptions);

            return options;
        },

        initialize: function (options) {
            this.channel = options && options.channel;
            this.hideImage = options && options.hideImage;

            FetchableCollectionView.prototype.initialize.apply(this, arguments);
        },
    });

    return GenericCardCollectionView;
});

